import {
  ApiResponse,
  Country,
  ExpenseYearlyReportListProps,
  MonthWiseExpenseData,
  getMonthWiseExpenseListProps,
} from '../../../../types/ExpenseManagement/ExpenseYearlyReport/expenseYearlyReportTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  expensesYearlyReportApiConfig,
} from '../../apiList'

const getExpenseYearlyReport = async (
  props: ExpenseYearlyReportListProps,
): Promise<ApiResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expensesYearlyReportApiConfig.getExpensesYearlyReport,
    method: AllowedHttpMethods.get,
    params: {
      categoryId: props.categoryId ?? '',
      country: props.country ?? '',
      departmentId: props.departmentId ?? '',
      fromDate: props.fromDate as '',
      toDate: props.toDate as '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCountryList = async (): Promise<Country[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expensesYearlyReportApiConfig.getContries,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getMonthWiseExpenseList = async (
  props: getMonthWiseExpenseListProps,
): Promise<MonthWiseExpenseData[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expensesYearlyReportApiConfig.getMonthWiseExpenseList,
    method: AllowedHttpMethods.get,
    params: {
      categoryId: props.categoryId ?? '',
      country: props.country ?? '',
      departmentId: props.departmentId ?? '',
      key: props.key ?? '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const expenseYearlyReportApi = {
  getExpenseYearlyReport,
  getCountryList,
  getMonthWiseExpenseList,
}

export default expenseYearlyReportApi
